export default __webpack_public_path__ + "static/media/11.f7fc2cb3.webp";